import React, { useEffect, createElement } from 'react';
import { ChevronDownIcon } from 'lucide-react';
export function HeroSection() {
  useEffect(() => {
    // Load Wistia player scripts
    const playerScript = document.createElement('script');
    playerScript.src = 'https://fast.wistia.com/player.js';
    playerScript.async = true;
    document.body.appendChild(playerScript);
    const embedScript1 = document.createElement('script');
    embedScript1.src = 'https://fast.wistia.com/embed/d8wlfmdbpm.js';
    embedScript1.async = true;
    embedScript1.type = 'module';
    document.body.appendChild(embedScript1);
    const embedScript2 = document.createElement('script');
    embedScript2.src = 'https://fast.wistia.com/embed/57hz5s9zbl.js';
    embedScript2.async = true;
    embedScript2.type = 'module';
    document.body.appendChild(embedScript2);
    const embedScript3 = document.createElement('script');
    embedScript3.src = 'https://fast.wistia.com/embed/ip8g7dbtna.js';
    embedScript3.async = true;
    embedScript3.type = 'module';
    document.body.appendChild(embedScript3);
    const embedScript4 = document.createElement('script');
    embedScript4.src = 'https://fast.wistia.com/embed/1mcznmxjps.js';
    embedScript4.async = true;
    embedScript4.type = 'module';
    document.body.appendChild(embedScript4);
    return () => {
      document.body.removeChild(playerScript);
      document.body.removeChild(embedScript1);
      document.body.removeChild(embedScript2);
      document.body.removeChild(embedScript3);
      document.body.removeChild(embedScript4);
    };
  }, []);
  const scrollToBooking = () => {
    const typeformElement = document.getElementById('typeform-embed');
    if (typeformElement) {
      typeformElement.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }
  };
  return <div className="bg-orange-700 text-white" data-id="element-82">
      <style dangerouslySetInnerHTML={{
      __html: `
          wistia-player[media-id='d8wlfmdbpm']:not(:defined) {
            background: center / contain no-repeat url('https://fast.wistia.com/embed/medias/d8wlfmdbpm/swatch');
            display: block;
            filter: blur(5px);
            padding-top: 56.25%;
          }
          wistia-player[media-id='57hz5s9zbl']:not(:defined) {
            background: center / contain no-repeat url('https://fast.wistia.com/embed/medias/57hz5s9zbl/swatch');
            display: block;
            filter: blur(5px);
            padding-top: 56.25%;
          }
          wistia-player[media-id='ip8g7dbtna']:not(:defined) {
            background: center / contain no-repeat url('https://fast.wistia.com/embed/medias/ip8g7dbtna/swatch');
            display: block;
            filter: blur(5px);
            padding-top: 56.25%;
          }
          wistia-player[media-id='1mcznmxjps']:not(:defined) {
            background: center / contain no-repeat url('https://fast.wistia.com/embed/medias/1mcznmxjps/swatch');
            display: block;
            filter: blur(5px);
            padding-top: 56.25%;
          }
        `
    }} data-id="element-83" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16 md:py-20 lg:py-24" data-id="element-84">
        <div className="text-center" data-id="element-85">
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold tracking-tight mb-6 sm:mb-8 leading-tight px-2" data-id="element-86">
            De Novato a Pro con IA: crea productos digitales y genera ventas sin
            experiencia.
          </h1>
          <p className="text-lg sm:text-xl md:text-2xl mb-8 sm:mb-10 text-orange-100 max-w-3xl mx-auto px-4" data-id="element-87">
            Clip de clase gratis
          </p>
          <div className="max-w-4xl mx-auto mb-8 sm:mb-10 px-2" data-id="element-88">
            <div className="bg-white rounded-lg shadow-2xl overflow-hidden" data-id="element-89">
              <div className="aspect-video" data-id="element-90">
                <wistia-player media-id="d8wlfmdbpm" aspect="1.7777777777777777" className="w-full h-full" data-id="element-91" />
              </div>
            </div>
          </div>
          <div className="max-w-4xl mx-auto mb-8 sm:mb-10 px-2" data-id="element-92">
            <div className="bg-white rounded-lg shadow-2xl overflow-hidden" data-id="element-93">
              <div className="aspect-video" data-id="element-94">
                <wistia-player media-id="57hz5s9zbl" aspect="1.7777777777777777" className="w-full h-full" data-id="element-95" />
              </div>
            </div>
          </div>
          <div className="max-w-4xl mx-auto mb-8 sm:mb-10 px-2" data-id="element-96">
            <div className="bg-white rounded-lg shadow-2xl overflow-hidden" data-id="element-97">
              <div className="aspect-video" data-id="element-98">
                <wistia-player media-id="ip8g7dbtna" aspect="1.7777777777777777" className="w-full h-full" data-id="element-99" />
              </div>
            </div>
          </div>
          <div className="max-w-4xl mx-auto mb-8 sm:mb-10 px-2" data-id="element-100">
            <div className="bg-white rounded-lg shadow-2xl overflow-hidden" data-id="element-101">
              <div className="aspect-video" data-id="element-102">
                <wistia-player media-id="1mcznmxjps" aspect="1.7777777777777777" className="w-full h-full" data-id="element-103" />
              </div>
            </div>
          </div>
          <button onClick={scrollToBooking} className="bg-yellow-400 hover:bg-yellow-500 text-orange-900 font-bold py-4 px-8 sm:py-5 sm:px-12 rounded-lg text-lg sm:text-xl shadow-2xl hover:shadow-3xl transition duration-300 transform hover:scale-105 mb-8 sm:mb-12" data-id="element-104">
            ¡Quiero Acceso Inmediato!
          </button>
          <div className="mt-8 sm:mt-12 flex flex-col items-center" data-id="element-105">
            <a href="#objection-handler" className="inline-flex flex-col items-center animate-bounce" data-id="element-106">
              <ChevronDownIcon className="h-10 w-10 sm:h-12 sm:w-12 text-yellow-400" strokeWidth={3} data-id="element-107" />
              <ChevronDownIcon className="h-10 w-10 sm:h-12 sm:w-12 text-yellow-400 -mt-5 sm:-mt-6" strokeWidth={3} data-id="element-108" />
              <ChevronDownIcon className="h-10 w-10 sm:h-12 sm:w-12 text-yellow-400 -mt-5 sm:-mt-6" strokeWidth={3} data-id="element-109" />
            </a>
          </div>
        </div>
      </div>
    </div>;
}